import React from 'react';
import Input from './bookComponents/Input';
import Booklist from './bookComponents/Booklist';
import './Header.css';

const Books = () => (
  <main>
    <Booklist />
    <Input />
  </main>
);

export default Books;
